import { PAPER_ELEMENT_TYPE } from '../../../../shared/constants/drawable-types'
import store from '../../../../stores'
import { updateSelectedPaperId } from '../../../slices/2D'
import { setActiveMasterSetPlanOption } from '../../../slices/masterSetPlan'

function select2DMasterSetPlanOption(): () => void {
    return function selectMasterSetPlanOption(this: paper.Path) {
        store.dispatch(setActiveMasterSetPlanOption(this.data.masterSetPlanId))
        store.dispatch(updateSelectedPaperId(this.id))
    }
}

function deselect2DMasterSetPlanOption(): () => void {
    return function deselectMasterSetPlanOption(this: paper.Path) {
        this.selected = false
        store.dispatch(setActiveMasterSetPlanOption(null))
        store.dispatch(updateSelectedPaperId(null))
    }
}

export default function addSelectFunctionalityToMasterSetPlanOption(masterSetPlanOptionPath: paper.PathItem): void {
    masterSetPlanOptionPath.data.type = PAPER_ELEMENT_TYPE.MASTER_SET_PLAN_OPTION
    masterSetPlanOptionPath.data.onSelect = select2DMasterSetPlanOption().bind(masterSetPlanOptionPath)
    masterSetPlanOptionPath.data.onDeselect = deselect2DMasterSetPlanOption().bind(masterSetPlanOptionPath)
}
